import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/*
 * Phase 2 ships this region hidden — no current "live campaigns with raised /
 * target / investors / sparkline trend" endpoint exists. Markup is in place
 * for Phase 2.5 to wire to the campaign list endpoint once available.
 */
export const SHOW_LIVE_CAMPAIGNS_TABLE = false;

const CampaignsTable = () => (
  <section className="card">
    <header className="card__head">
      <h2 className="card__title">Live campaigns</h2>
      <span className="card__sub">— TBD endpoint —</span>
      <div className="card__head-right">
        <Link className="btn-link" to="/active-campaign">All campaigns <ChevronRight /></Link>
      </div>
    </header>
    <div className="card__body" style={{ color: "var(--tx-3)", fontSize: "var(--t-sm)" }}>
      Live campaigns table will populate once the backend exposes a "top live
      campaigns" aggregation. Tracked as Phase 2.5.
    </div>
  </section>
);

export default CampaignsTable;
